import z from "zod";

const MonthlyInspectionDetailSchema = z.object({
  comfirmation_date: z.string(),
  theme: z.string().trim(),
  content: z.string().trim(),
  inspection_results: z.array(z.boolean()),
  comments: z.string().trim(),
});

export { MonthlyInspectionDetailSchema };
